import { render } from "./Contacts.vue?vue&type=template&id=2cbd85df"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=2cbd85df&lang=css"

import exportComponent from "D:\\node projects\\jsmethod\\vue-app\\landing-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__